class AlgoliaIconExpandCollapse extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      iconSize: this.getAttribute('icon-size'),
      type: this.getAttribute('type')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .expand-collapse-icon .expand-icon,
      .expand-collapse-icon .collapse-icon {
        height: ${this.settings.iconSize}px;
        width: ${this.settings.iconSize}px;
      }
    `
    style.appendChild(document.createTextNode(css));
    return style;
  }

  createCollapseIcon() {
    const iconCaretDown = this.querySelector('algolia-icon-caret-down');
    const iconMinus = this.querySelector('algolia-icon-minus');
    const iconCaretDownContent = iconCaretDown ? iconCaretDown.render() : [];
    const iconMinusContent = iconMinus ? iconMinus.render() : [];
    
    const collapseIconDiv = document.createElement('div');
    collapseIconDiv.classList.add('collapse-icon');
    const collapseIconSpan = document.createElement('span');
    const collapseIconSpanInner = document.createElement('span');
    collapseIconSpanInner.classList.add('visually-hidden');
    collapseIconSpanInner.textContent = 'Collapse';
    collapseIconSpan.appendChild(collapseIconSpanInner);

    if (this.settings.type === 'caret') {
      iconCaretDownContent.forEach(element => collapseIconSpan.appendChild(element));
    } else {
      iconMinusContent.forEach(element => collapseIconSpan.appendChild(element));
    }

    collapseIconDiv.appendChild(collapseIconSpan);

    return collapseIconDiv;
  }
  
  createExpandIcon() {
    const iconCaretUp = this.querySelector('algolia-icon-caret-up');
    const iconPlus = this.querySelector('algolia-icon-plus');
    const iconCaretUpContent = iconCaretUp ? iconCaretUp.render() : [];
    const iconPlusContent = iconPlus ? iconPlus.render() : [];
    const expandIconDiv = document.createElement('div');
    expandIconDiv.classList.add('expand-icon');
    const expandIconSpan = document.createElement('span');
    const expandIconSpanInner = document.createElement('span');
    expandIconSpanInner.classList.add('visually-hidden');
    expandIconSpanInner.textContent = 'Expand';
    
    expandIconSpan.appendChild(expandIconSpanInner);

    if (this.settings.type === 'caret') {
      iconCaretUpContent.forEach(element => expandIconSpan.appendChild(element));
    } else {
      iconPlusContent.forEach(element => expandIconSpan.appendChild(element));
    }
    expandIconDiv.appendChild(expandIconSpan);
    return expandIconDiv;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const expandCollapseDiv = document.createElement('div');
    expandCollapseDiv.classList.add('expand-collapse-icon');
    expandCollapseDiv.appendChild(this.createExpandIcon());

    
    expandCollapseDiv.appendChild(this.createCollapseIcon());

    return [style, expandCollapseDiv];
  }
}

customElements.define("algolia-icon-expand-collapse", AlgoliaIconExpandCollapse);